import { ChangeDetectorRef, Component } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { CommonApiService } from '../../spartacus/services/common-api.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { Observable } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-custom-payment-info',
    templateUrl: './custom-payment-info.component.html',
    styleUrls: ['./custom-payment-info.component.scss'],
    standalone: false
})
export class CustomPaymentInfoComponent {
  paymentDetails: any;
  compData: Observable<any> = this.componentData.data$;
  constructor(private occEndpointsService:OccEndpointsService,
    private commonService:CommonApiService,private cd:ChangeDetectorRef,
    private userInfoService: UserInfoService,public componentData:CmsComponentData<any>){

  }
  ngOnInit(){
      this.getPaymentDetails();

  }
getPaymentDetails(){ 
  this.userInfoService.getsavedcard().subscribe(
    (data) => {
      if (data) {
       
        this.paymentDetails=data;
       
        this.cd.detectChanges();
      }
     
    },
    (error) => {
      console.log('error');
     
    }
  );
  
    /* let endpoint = this.occEndpointsService.buildUrl(`/users/${this.commonService.userId}/my-profile/savedCards`);
    let payload = {
      url: endpoint,
    }
    this.paymentDetails$=this.commonService.getAPICall(payload); */
  }
}
